if(!customElements.get('tabs-bullets')) {

  class ComponentTabBullets extends HTMLElement {
    constructor() {
      super()  

      this.querySelectorAll('.has-dropdown').forEach((element)=>{

        element.addEventListener('click', function(e){
            e.preventDefault();

            var parent = element.parentNode;
            parent.classList.toggle('active');
            var panel = parent.querySelector('.panel');
            if (parent.classList.contains('active')) {
              element.setAttribute('aria-expanded', 'true');
              panel.classList.add('open');
              $s.expand([panel],{'duration': 200, 'effect': 'ease-out'} );
            } else {
              element.setAttribute('aria-expanded', 'false');
              panel.classList.remove('open');
              $s.collapse([panel],{'duration': 200, 'effect': 'ease-out'});
            }
            return false;
        })

      });

    }

  
  }
  customElements.define('tabs-bullets', ComponentTabBullets);

}
